import React from 'react';
import Table from '../../components/common/Table';
import { BASE_URL } from '../../config/config';
import { convertToUserTime } from '../../utils/helpers/convertToUserTime';

interface CampaignTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CampaignTable: React.FC<CampaignTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Donation Link',
          key: 'id',
          render: (campaign) => {
            const donationUrl = `${BASE_URL}campaign-donation/${campaign.id}`;
            return (
              <a
                href={donationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline break-all"
              >
                {donationUrl}
              </a>
            );
          },
        },
        {
          label: 'Created',
          key: 'createdUtc',
          render: (row) => <span>{convertToUserTime(row.createdUtc)}</span>
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CampaignTable;
